import React, { } from 'react';
import { constants, Globals } from '../../../misc/helpers';
import Dragger from '../helpers/Dragger';
import './TourniquetePlacement.css';


const TourniquetePlacement = (obj: any) => {
	var onClick = (placementIndx: number) => {
		var isCorrect1 = placementIndx === obj.parameters.correctIndex1;
		var isCorrect2 = placementIndx === obj.parameters.correctIndex2;
		var isWrong = placementIndx === obj.parameters.wrong;
		var isClose = placementIndx === obj.parameters.close;
		if( (!obj.parameters.ignorePlacement && isCorrect1 && obj.parameters.isTutorial2) || obj.parameters.isTestScenario || (obj.parameters.isPractice && isCorrect1) ) {
			obj.parameters.dispatch({
				type: 'playSequence',
				value: {
					sequenceName: 'TorniqueteLocation' + placementIndx,
					skipAnimations: Globals.skipAnimations
				}
			});
		}

		if (obj.parameters.onDone) {
			if(obj.parameters.isTutorial) {
				obj.parameters.onDone(placementIndx, (isWrong || isClose))
			}
			else if (obj.parameters.isPractice) {
				obj.parameters.onDone(placementIndx, (isCorrect1 || isCorrect2))
			}
			else if(obj.parameters.isTestScenario) {
				obj.parameters.onDone(placementIndx, (isCorrect1 || isCorrect2 || isWrong || isClose))
			}
			else {
				obj.parameters.onDone(placementIndx, (isCorrect1 || isCorrect2))
			}
		}
	};

	const getPlacementType = (type: number) => {
		if(obj.parameters.isTestScenario) {
			return 'test-scenario';
		}
		else if(obj.parameters.isTutorial) {
			return type == constants.placementType.wrong? 'wrong' : 'tutorial';
		}
		else if(obj.parameters.isPractice) {
			return type == constants.placementType.correct1 ? 'correct' : type == constants.placementType.correct2 ? 'correct' : 'tutorial';
		}
		else {return type == constants.placementType.wrong ? 'wrong' : type == constants.placementType.close ? 'close' : 'correct';}
	};

	return (
		<div className="ui-container modal-disable-select">
			<div className="ui-inner-container tourniquete-container">

				<Dragger 
					getPlacementType={(type: number) => {
						return getPlacementType(type);
					}} 
					correctIndex1={obj.parameters.correctIndex1} 
					correctIndex2={obj.parameters.correctIndex2} 
					wrongIndex={obj.parameters.wrongIndex} 
					closeIndex={obj.parameters.closeIndex} 
					locations={obj.parameters.locations} 
					isSceneA={obj.parameters.isSceneA} 
					isSceneB={obj.parameters.isSceneB} 
					isSceneC={obj.parameters.isSceneC} 
					isSceneD={obj.parameters.isSceneD} 
					endDrag={onClick} />
			</div>
		</div>
	);
};

export default TourniquetePlacement;
